import { FC } from 'react';
import { FloatButton } from 'antd';
import { FloatButtonGroupProps } from 'antd/lib/float-button/interface';

export type ProFloatButtonGroupProps = FloatButtonGroupProps;

const Index: FC<ProFloatButtonGroupProps> = props => {
  return (
    <FloatButton.Group {...props} />
  );
};

export default Index;